var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleRoundedMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 129,
    viewBox: "0 0 156 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.86401C0 4.47924 4.36522 0.114014 9.75 0.114014H36C102.274 0.114014 156 53.8398 156 120.114C156 124.532 152.418 128.114 148 128.114H20C8.9543 128.114 0 119.16 0 108.114V9.86401Z",
    fill: "#83E4DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleRoundedMobile);
export default __webpack_public_path__ + "static/media/rectangle-rounded-mobile.4b5cc9e89930d623e21ae61eda38ebdc.svg";
export { ForwardRef as ReactComponent };